import { getPatientFormularyForDrug } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  GetPatientFormularyForDrugParams,
  PatientFormularyResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

/**
 * Live ``GET /dosespot/patients/{user_id}/formulary`` — wraps DoseSpot's
 * ``/formulary`` lookup for a single NDC under a single coverage.
 *
 * Designed for the Rx wizard: fires the moment a medication is selected
 * so we can surface formulary status, drug-specific copays, payer
 * alternatives, therapeutic alternatives, and restrictions before the
 * clinician finalises the draft. The endpoint accepts a partial input
 * set (just ``dispensable_drug_id`` is enough; pharmacy and coverage are
 * resolved server-side) so the client can call it as soon as a drug is
 * selected without waiting for pharmacy / quantity to fill in.
 */
export async function fetchPatientFormulary(
  userId: string,
  params: GetPatientFormularyForDrugParams,
  signal?: AbortSignal
): Promise<PatientFormularyResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPatientFormularyForDrug(userId, params, config);
  return lotusHealthZod.getPatientFormularyForDrugResponse.parse(
    response.data
  ) as PatientFormularyResponseT;
}
